import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { AppProvider } from "./context/AppContext";
import Login from "./pages/Login";
import ChatList from "./pages/ChatList";
import Chat from "./pages/Chat";
import AdminPanel from "./pages/AdminPanel";
import Layout from "./components/Layout";
import PageTransition from "./components/PageTransition";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isAdmin } = useAuth();
  return isAuthenticated && isAdmin ? <>{children}</> : <Navigate to="/" />;
};

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppProvider>
        <AuthProvider>
          <Router>
            <Routes>
              <Route
                path="/login"
                element={
                  <PageTransition>
                    <Login />
                  </PageTransition>
                }
              />
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Layout>
                      <PageTransition>
                        <ChatList />
                      </PageTransition>
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/chat/:chatId"
                element={
                  <PrivateRoute>
                    <PageTransition>
                      <Chat />
                    </PageTransition>
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <Layout>
                      <PageTransition>
                        <AdminPanel />
                      </PageTransition>
                    </Layout>
                  </AdminRoute>
                }
              />
            </Routes>
          </Router>
        </AuthProvider>
      </AppProvider>
    </ThemeProvider>
  );
};

export default App;
